import ToastService from "./Toast.Service";
import Router, {useRouter} from "next/router";
class InvoiceServices {

  detachClient(jwtToken, invoiceData) {
    const data = {
      client_id: null,
    };

    const promise = fetch(
      process.env.NEXT_PUBLIC_CRAFT_BASE_URL +
        `/api/invoices/${invoiceData?.uid}/update`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${jwtToken}`,
        },
        body: JSON.stringify(data),
      }
    )
      .then((response) => response)
      .then(async (data) => {
        return {
          ok: data.ok,
          data: await data.json(),
        };
      })
      .then((data) => {
        if (!data.ok) {
          throw data.data.message;
        }

        window.location.reload();
      });

    ToastService.promiseToast(promise);
  }

  attachClient(offerteId, clientId, jwtToken) {
    const data = {
      client_id: clientId,
    };

    const promise = fetch(
      process.env.NEXT_PUBLIC_CRAFT_BASE_URL +
        "/api/invoices/" +
        offerteId +
        "/update",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${jwtToken}`,
        },
        body: JSON.stringify(data),
      }
    )
      .then((response) => response)
      .then(async (data) => {
        return {
          ok: data.ok,
          data: await data.json(),
        };
      })
      .then((data) => {
        if (!data.ok) {
          throw data.data.message;
        }
      });

    ToastService.promiseToast(promise);
  }
  duplicate(jwtToken, uid) {

    const promise = fetch(
      process.env.NEXT_PUBLIC_CRAFT_BASE_URL +
        "/api/invoices/" +
        uid +
        "/duplicate",
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwtToken}`,
        },
      }
    )
      .then((response) => response)
      .then(async (data) => {
        return {
          ok: data.ok,
          data: await data.json(),
        };
      })
      .then((data) => {
        if (!data.ok) {
          throw data.data.message;
        }

        Router.push("/offerte/bewerken/" + data?.data[0]?.uid);
      });

    ToastService.promiseToast(promise);
  }

  async create(jwtToken, reference, client_id) {
      if (!reference) {
          ToastService.errorToast('Offerte heeft geen naam');
          return;
      }

      const promise = fetch(`${process.env.NEXT_PUBLIC_CRAFT_BASE_URL}/api/invoices/create`,{
          method: "POST",
          headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              Authorization: `Bearer ${jwtToken}`,
          },
          body: JSON.stringify({reference, client_id}),
      })
          .then((response) => response)
          .then(async (data) => {
              return {
                  ok: data.ok,
                  data: await data.json(),
              };
          })
          .then((data) => {
              if (!data.ok) {
                  throw data.data.message;
              }

              if (typeof window !== 'undefined') {
                  localStorage.setItem(
                      'quotation',
                      JSON.stringify({uid: data.data.uid, reference})
                  );
              }


              Router.push(`/offerte/bewerken/${data.data.uid}`);

          });

      ToastService.promiseToast(promise);
  }

  async selfclient(jwtToken, invoiceId) {
    await fetch(
      process.env.NEXT_PUBLIC_CRAFT_BASE_URL + "/api/clients/create-self",
      {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwtToken}`,
        },
      }
    )
      .then((response) => response)
      .then(async (data) => {
        return {
          ok: data.ok,
          data: await data.json(),
        };
      })
      .then((data) => {
        if (!data.ok) {
          throw data.data.message;
        }

        this.attachClient(invoiceId, data.data.id, jwtToken);
        Router.reload();
      });
  }

    async splitQuotation(jwtToken, uid) {
        await fetch(
            process.env.NEXT_PUBLIC_CRAFT_BASE_URL +
            "/api/invoices/" +
            uid +
            "/split",
            {
                method: "post",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${jwtToken}`,
                },
            }
        )
            .then((response) => response)
            .then(async (data) => {
                return {
                    ok: data.ok,
                    data: await data.json(),
                };
            })
            .then((data) => {
                if (!data.ok) {
                    throw data.data.message;
                }
            });
    }
}

export default new InvoiceServices();
